import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { CORES_PRESET } from "../constants/colors";
import { PRODUTO_DEMO_NOME } from "../constants/seedDemo";
// Semeia uma conta nova com um filamento e um produto de exemplo — evita a
// sensação de "app vazio" no primeiro acesso e já mostra pro usuário como
// os cadastros aparecem. Escrito direto com addDoc (não fbAdd) porque nesse
// momento ainda não existe sessão salva (getUser() retornaria null e
// gravaria fora do espaço do usuário) — o uid já é conhecido aqui.
export async function semearContaNova(uid) {
  try {
    const cor = CORES_PRESET[Math.floor(Math.random() * CORES_PRESET.length)];
    await setDoc(doc(db, `users/${uid}/filamentos`, "demo-filamento"), {
      nome: ["PLA", cor.nome].filter(Boolean).join(" "),
      material: "PLA",
      cor: cor.nome,
      peso: 1000,
      peso_restante: 1000,
      custo: 100,
      marca: null,
      created_at: serverTimestamp(),
    });
  } catch (e) { console.error("Erro ao semear filamento de exemplo:", e); }
  try {
    await setDoc(doc(db, `users/${uid}/produtos`, "demo-produto"), {
      nome: PRODUTO_DEMO_NOME,
      preco: 45,
      estoque: 10,
      categoria: "Decoração",
      fotoBase64: null,
      ativo: false,
      filamentos_usados: [],
      materiais_usados: [],
      created_at: serverTimestamp(),
    });
  } catch (e) { console.error("Erro ao semear produto de exemplo:", e); }
}
